import React from "react";
import * as selectStyles from "./Select.css";

interface TriggerContentWrapperProps {
  /**
   * Trigger content — value(s) or placeholder.
   */
  children: React.ReactNode;
  /**
   * Ref to the row holding the content, for consumers that measure it.
   */
  rowRef?: React.Ref<HTMLDivElement>;
}

/**
 * Layout wrapper for aligning trigger content (used in both variants).
 */
export function TriggerContentWrapper({
  children,
  rowRef
}: TriggerContentWrapperProps): React.ReactElement {
  return (
    <div className={selectStyles.selectRowBetween}>
      <div ref={rowRef} className={selectStyles.selectWrapCenter}>
        {children}
      </div>
    </div>
  );
}

/**
 * Renders static or dynamic text inside the trigger.
 */
export function TriggerText({ text }: { text?: string }): React.ReactElement {
  return <span className={selectStyles.selectTriggerText}>{text}</span>;
}
